import React, { createContext, useContext, useState } from "react";

const AdminLayoutContext = createContext();

export const useAdminLayout = () => useContext(AdminLayoutContext);

export const AdminLayoutProvider = ({ children }) => {
  const [layoutConfig, setLayoutConfig] = useState({
    title: "Admin Panel",
    showBackButton: false,
    scrollable: true,
  });

  return (
    <AdminLayoutContext.Provider value={{ layoutConfig, setLayoutConfig }}>
      {children}
    </AdminLayoutContext.Provider>
  );
};